import { render, staticRenderFns } from "./deviceversion.vue?vue&type=template&id=cadac36c&scoped=true&"
import script from "./deviceversion.vue?vue&type=script&lang=js&"
export * from "./deviceversion.vue?vue&type=script&lang=js&"
import style0 from "./deviceversion.vue?vue&type=style&index=0&id=cadac36c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadac36c",
  null
  
)

export default component.exports